import { FONTS, PALETTE } from "./theme";

export const WHATS_ON_CSS = `
.bwo-root { background: ${PALETTE.pageBg}; color: ${PALETTE.ink}; font-family: ${FONTS.sans}; padding: 24px; border-radius: 12px; box-sizing: border-box; }
.bwo-root *, .bwo-root *::before, .bwo-root *::after { box-sizing: inherit; }
.bwo-title { font-family: ${FONTS.serif}; font-size: 28px; margin: 0 0 16px; }

/* chips row */
.bwo-chips { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; }
.bwo-chip-filter { border: 1px solid ${PALETTE.border}; border-radius: 999px; padding: 6px 14px; font: inherit; font-size: 13px; cursor: pointer; background: transparent; color: ${PALETTE.ink}; display: inline-flex; align-items: center; gap: 6px; }
.bwo-chip-filter--off { opacity: 0.45; }
.bwo-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; flex: none; }

/* view toggle + month nav */
.bwo-controls { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; margin-bottom: 16px; }
.bwo-toggle { display: inline-flex; border: 1px solid ${PALETTE.ink}; border-radius: 999px; overflow: hidden; }
.bwo-toggle button { border: 0; background: transparent; color: ${PALETTE.ink}; font: inherit; font-size: 13px; padding: 8px 18px; cursor: pointer; }
.bwo-toggle button[aria-pressed="true"] { background: ${PALETTE.ink}; color: ${PALETTE.pageBg}; }
.bwo-monthnav { display: flex; align-items: center; gap: 12px; }
.bwo-monthnav h3 { font-family: ${FONTS.serif}; font-size: 20px; margin: 0; min-width: 170px; text-align: center; }
.bwo-monthnav button { border: 1px solid ${PALETTE.border}; background: transparent; color: ${PALETTE.ink}; border-radius: 50%; width: 34px; height: 34px; font-size: 16px; cursor: pointer; }
.bwo-monthnav button:disabled { opacity: 0.35; cursor: default; }

/* calendar grid */
.bwo-grid { display: grid; grid-template-columns: repeat(7, minmax(0, 1fr)); gap: 4px; }
.bwo-dow { font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: ${PALETTE.muted}; text-align: center; padding: 6px 0; }
.bwo-cell { background: ${PALETTE.pageBg}; border-radius: 8px; min-height: 96px; min-width: 0; padding: 6px; display: flex; flex-direction: column; gap: 4px; }
.bwo-cell--inmonth { background: ${PALETTE.cell}; border: 1px solid ${PALETTE.panel}; }
.bwo-cell--today { outline: 2px solid ${PALETTE.accent}; outline-offset: -2px; }
.bwo-cell-day { font-size: 12px; color: ${PALETTE.mutedAlt}; }
.bwo-chip { border: 0; text-align: left; font: inherit; font-size: 11px; line-height: 1.3; border-radius: 6px; padding: 3px 6px; cursor: pointer; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; }
.bwo-chip--soldout { opacity: 0.55; }
.bwo-more { border: 0; background: transparent; color: ${PALETTE.accent}; font: inherit; font-size: 11px; cursor: pointer; text-align: left; padding: 0 6px; }
.bwo-dots { display: none; }

/* list view */
.bwo-list { display: flex; flex-direction: column; gap: 8px; }
.bwo-day-heading { font-family: ${FONTS.serif}; font-size: 16px; margin: 12px 0 4px; }
.bwo-row { display: flex; align-items: center; gap: 14px; background: ${PALETTE.cell}; border: 1px solid ${PALETTE.panel}; border-radius: 10px; padding: 12px 16px; }
.bwo-row--highlight { border-color: ${PALETTE.accent}; box-shadow: 0 0 0 2px ${PALETTE.accent}40; }
.bwo-row-date { font-family: ${FONTS.serif}; font-size: 14px; min-width: 56px; color: ${PALETTE.muted}; }
.bwo-row-main { flex: 1; min-width: 0; }
.bwo-row-cat { display: flex; align-items: center; gap: 6px; font-size: 11px; text-transform: uppercase; letter-spacing: 0.05em; color: ${PALETTE.mutedAlt}; }
.bwo-row-title { font-family: ${FONTS.serif}; font-size: 17px; margin: 2px 0; }
.bwo-row-meta { font-size: 13px; color: ${PALETTE.muted}; }
.bwo-spots { color: ${PALETTE.accent}; font-weight: 600; margin-left: 8px; }
.bwo-book { border: 0; background: ${PALETTE.ink}; color: ${PALETTE.pageBg}; font: inherit; font-size: 13px; border-radius: 999px; padding: 9px 18px; cursor: pointer; flex: none; }
.bwo-soldout-label { color: ${PALETTE.mutedAlt}; font-size: 13px; flex: none; }

/* states */
.bwo-skeleton { border-radius: 10px; background: linear-gradient(90deg, ${PALETTE.panel}, ${PALETTE.pageBg}, ${PALETTE.panel}); background-size: 200% 100%; animation: bwo-shimmer 1.4s infinite; min-height: 72px; }
@keyframes bwo-shimmer { from { background-position: 200% 0; } to { background-position: -200% 0; } }
.bwo-empty, .bwo-error { background: ${PALETTE.panel}; border-radius: 10px; padding: 32px; text-align: center; color: ${PALETTE.muted}; }
.bwo-retry { border: 1px solid ${PALETTE.ink}; background: transparent; color: ${PALETTE.ink}; font: inherit; border-radius: 999px; padding: 8px 18px; margin-top: 12px; cursor: pointer; }

/* day panel (mobile tap-a-day) */
.bwo-daypanel { margin-top: 12px; }

/* mobile */
@media (max-width: 719px) {
  .bwo-root { padding: 14px; }
  .bwo-cell { min-height: 52px; }
  .bwo-cell .bwo-chip, .bwo-cell .bwo-more { display: none; }
  .bwo-dots { display: flex; gap: 3px; flex-wrap: wrap; }
  .bwo-cell--selected { outline: 2px solid ${PALETTE.ink}; outline-offset: -2px; }
  .bwo-row { flex-wrap: wrap; }
}
`;
